import { yesNoUI } from 'platform/forms-system/src/js/web-component-patterns';
import UnauthenticatedWarningAlert from '../../../components/UnauthenticatedWarningAlert';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    'view:warningAlert': {
      'ui:description': UnauthenticatedWarningAlert,
    },
    claimantNotVeteran: yesNoUI({
      title: content['relationship-title'],
      labelHeaderLevel: 3,
      yesNoReverse: true,
      labels: {
        Y: content['relationship-veteran-label'],
        N: content['relationship-non-veteran-label'],
      },
    }),
  },
  schema: {
    type: 'object',
    required: ['claimantNotVeteran'],
    properties: {
      'view:warningAlert': {
        type: 'object',
        properties: {},
      },
      claimantNotVeteran: {
        type: 'boolean',
      },
    },
  },
};
